import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "sms-receivers"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-trash" }, null, -1)
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_5 = {
  key: 1,
  class: "email-receivers"
}
const _hoisted_6 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CButton = _resolveComponent("CButton")!
  const _component_CModalTitle = _resolveComponent("CModalTitle")!
  const _component_CModalHeader = _resolveComponent("CModalHeader")!
  const _component_CFormInput = _resolveComponent("CFormInput")!
  const _component_CInputGroupText = _resolveComponent("CInputGroupText")!
  const _component_CInputGroup = _resolveComponent("CInputGroup")!
  const _component_CModalBody = _resolveComponent("CModalBody")!
  const _component_CModalFooter = _resolveComponent("CModalFooter")!
  const _component_CModal = _resolveComponent("CModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_CButton, {
      color: "success",
      onClick: _cache[0] || (_cache[0] = () => { _ctx.showPicker = true })
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.options.buttonText), 1)
      ]),
      _: 1
    }),
    _createVNode(_component_CModal, {
      alignment: "center",
      visible: _ctx.showPicker,
      onClose: _cache[4] || (_cache[4] = () => { _ctx.showPicker = false })
    }, {
      default: _withCtx(() => [
        _createVNode(_component_CModalHeader, null, {
          default: _withCtx(() => [
            _createVNode(_component_CModalTitle, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.options.title), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_CModalBody, null, {
          default: _withCtx(() => [
            (_ctx.isSmsReceiver)
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                  _createTextVNode(" SMS "),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.receivers, (receiver, index) => {
                    return (_openBlock(), _createBlock(_component_CInputGroup, null, {
                      default: _withCtx(() => [
                        (_openBlock(), _createBlock(_component_CFormInput, {
                          key: index,
                          modelValue: _ctx.receivers[index],
                          "onUpdate:modelValue": ($event: any) => ((_ctx.receivers[index]) = $event),
                          type: "text",
                          placeholder: "+48111222333",
                          autocomplete: "phoneNumber"
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])),
                        _createVNode(_component_CInputGroupText, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_CButton, {
                              onClick: ($event: any) => (_ctx.deleteReceiver(index))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_2
                              ]),
                              _: 2
                            }, 1032, ["onClick"])
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024))
                  }), 256)),
                  (_ctx.msg.length > 0)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_3, [
                        _hoisted_4,
                        _createTextVNode(" " + _toDisplayString(_ctx.msg), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createTextVNode(" Emails "),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userEmails, (email, index) => {
                    return (_openBlock(), _createElementBlock("div", { key: index }, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        value: email,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.checkedEmails) = $event)),
                        onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toggleEmail()))
                      }, null, 40, _hoisted_6), [
                        [_vModelCheckbox, _ctx.checkedEmails]
                      ]),
                      _createTextVNode(" " + _toDisplayString(email), 1)
                    ]))
                  }), 128))
                ]))
          ]),
          _: 1
        }),
        (_ctx.isSmsReceiver)
          ? (_openBlock(), _createBlock(_component_CModalBody, { key: 0 }, {
              default: _withCtx(() => [
                _createVNode(_component_CButton, {
                  color: "success",
                  onClick: _ctx.addReceiver
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Dodaj użytkownika")
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_CButton, {
                  color: "secondary",
                  onClick: _ctx.resetReceivers
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Usuń wszystkich")
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_CModalFooter, null, {
          default: _withCtx(() => [
            _createVNode(_component_CButton, {
              color: "secondary",
              onClick: _cache[3] || (_cache[3] = () => { _ctx.showPicker = false })
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Zamknij ")
              ]),
              _: 1
            }),
            _createVNode(_component_CButton, {
              color: "success",
              onClick: _ctx.setReceivers
            }, {
              default: _withCtx(() => [
                _createTextVNode("Zapisz zmiany")
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}